const GroupSearchFieldNames = {
  FREE_TEXT: 'free-text',
  COUNTY: 'county',
  DAYS: 'days',
  TIMES: 'times',
  VENUE_ACCESSIBILITY: 'venueAccessibility',
};

export default GroupSearchFieldNames;
